module.exports = __webpack_public_path__ + "static/media/patjarmerah.f0ff7087.png";